export enum MobileAccountRoutesEnum {
  root = 'account',
  activateBiometricsFirstTime = 'activate-biometrics-first-time',
}
